export default {
  init() {
    // JavaScript to be fired on all pages
    $('.gallery-top').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: true,
      adaptiveHeight: true,
      asNavFor: '.gallery-bottom',
    });

    $('.gallery-bottom').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      infinite: true,
      adaptiveHeight: false,
      asNavFor: '.gallery-top',
      focusOnSelect: true,
      centerMode: true,
      centerPadding: '0px',
    });

    $('.featured-products').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: true,
      adaptiveHeight: false,
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleGallery.js